/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 *
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 *
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
 */
import * as Blockly from 'blockly/core';
import 'blockly/python';
import { getAllowedOutputs, getAllowedStatements } from '../block_compatibility_checks';
import { getParentBlockByType} from '../dataset';

// -------------------------------------- HISTOGRAM -----------------------------------------------
// Band histogram
Blockly.Blocks['output_band_histogram'] = {
    init: function () {
        this.appendValueInput("y_input")
            .setCheck(getAllowedStatements('scatter_y_input'))
            .appendField("Histogram. Bands or indices: ", "hist_text")
        this.appendDummyInput("params")
            .appendField("No of bins: ")
            .appendField(new Blockly.FieldNumber(25, 1, 10000), "no_bins")
            .appendField(" Min: ")
            .appendField(new Blockly.FieldTextInput("default", this.validator.bind(this)), "min")
            .appendField(" Max: ")
            .appendField(new Blockly.FieldTextInput("default", this.validator.bind(this)), "max")
        this.setPreviousStatement(true, 'histogram');
        this.setNextStatement(true, getAllowedOutputs('histogram'))
        this.setInputsInline(false);
        this.setStyle('dashboards');
        this.setTooltip(Blockly.Msg.HISTOGRAM_BLOCK_TOOLTIP);
        this.setHelpUrl("");
        this.setOnChange(function () {
            if (getParentBlockByType(this, "input_climate_data") !== null || getParentBlockByType(this, 'input_dem_data') !== null) {
                this.updateCheck('single_input');
            } else {
                this.updateCheck('mult_input');
            }
        });
    },

    validator: function (inputText) {
        if (isNaN(parseFloat(inputText)) == false) {
            return inputText;
        } else {
            return "default";
        }
    },

    updateCheck: function (inp) {
        if (inp == 'single_input') {
            this.getInput("y_input").setCheck(getAllowedStatements('scatter_single_y_input'));
        } else {
            this.getInput("y_input").setCheck(getAllowedStatements('scatter_y_input'));
        }
    }
};